import produce from "immer";
import create, { State } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { PatientFlowType, storageTypes } from "../../app/shared/config";

interface FormStore extends State {
  isGuardian: boolean;
  newPatientID: number;
  patientFlow: string;
  isValidDate: boolean;
  isCcConsentCaptured: boolean;
  guardianRelationship: string;
  setPatientFlow: (patientFlow: string) => void;
  setIsGuardian: (isGuardian: boolean) => void;
  setNewPatientID: (newPatientID: number) => void;
  setIsValidDate: (isValidDate: boolean) => void;
  setCcConsentCaptured: (isCcConsentCaptured: boolean) => void;
  setguardianRelationship: (patientYourselfRelationship: string) => void;
}

const useFormStore = create<FormStore>(
  persist(
    devtools(
      (set) => ({
        isGuardian: false,
        patientFlow: PatientFlowType.Yourself,
        isValidDate: true,
        newPatientID: null,
        isCcConsentCaptured: false,
        guardianRelationship: null,
        setNewPatientID: (props) =>
          set(
            produce((state) => {
              state.newPatientID = props;
            }),
            false,
            "formData/setNewPatientID"
          ),
        setIsGuardian: (props) =>
          set(
            produce((state) => {
              state.isGuardian = props;
            }),
            false,
            "formData/setIsGuardian"
          ),
        setPatientFlow: (props) =>
          set(
            produce((state) => {
              state.patientFlow = props;
            }),
            false,
            "formData/setPatientFlow"
          ),
        setIsValidDate: (props) =>
          set(
            produce((state) => {
              state.isValidDate = props;
            }),
            false,
            "formData/setIsValidDate"
          ),
        setCcConsentCaptured: (props) =>
          set(
            produce((state) => {
              state.isCcConsentCaptured = props;
            }),
            false,
            "formData/setCcConsentCaptured"
          ),
        setguardianRelationship: (props) =>
          set(
            produce((state) => {
              state.guardianRelationship = props;
            }),
            false,
            "formData/setguardianRelationship"
          ),
      }),
      { name: "formData", serialize: true }
    ),
    {
      name: "formData", // unique name
      getStorage: () => storageTypes.session, // (optional) by default, 'localStorage' is used
    }
  )
);

export default useFormStore;
